// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"LW-z","sponsoredTooltipWrapper":"MW-z","sponsoredTooltip":"NW-z","newCard":"OW-z"};